import { render, staticRenderFns } from "./AddWorkDialog.vue?vue&type=template&id=35575c0f&"
import script from "./AddWorkDialog.vue?vue&type=script&lang=js&"
export * from "./AddWorkDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports